"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyUseModelisationProd = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const file_saver_1 = __importDefault(require("file-saver"));
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const OpenSankey_1 = require("./OpenSankey");
const d3 = __importStar(require("d3"));
const SupplyUseModelisationProd = ({ ref_setter_show_reconciliation, action_type, sankey_data, set_sankey_data, DefaultSankeyData, callback }) => {
    const [result, setResult] = (0, react_1.useState)('');
    const [processing, setProcessing] = (0, react_1.useState)(false);
    const [failure, setFailure] = (0, react_1.useState)(false);
    const [not_started, setNotStarted] = (0, react_1.useState)(true);
    const [value, setValue] = (0, react_1.useState)([1, 2]);
    const [regions, setRegions] = (0, react_1.useState)(false);
    const [uncertainty, setUncertainty] = (0, react_1.useState)(false);
    const [nb_realizations, setNbRealizations] = (0, react_1.useState)(100);
    const [input_file_name, setInputFileName] = (0, react_1.useState)('sankey.xlsx');
    const [layout_file, set_layout_file] = (0, react_1.useState)(undefined);
    const [input_file, set_input_file] = (0, react_1.useState)(undefined);
    const _load_excel = (0, react_1.useRef)(null);
    const [show_reconciliation, set_show_reconciliation] = (0, react_1.useState)(false);
    ref_setter_show_reconciliation.current = set_show_reconciliation;
    let upper_level_file_ = (0, react_1.useRef)(null);
    const setNbRealisations = (e) => {
        setNbRealizations(e.target.value);
    };
    const uncertaintyChange = (e) => {
        setUncertainty(e.target.checked);
    };
    const handleChange = (evt) => {
        if (value.includes(+evt.target.value)) {
            value.splice(value.indexOf(evt.target.value));
        }
        else {
            value.push(+evt.target.value);
        }
        setValue([...value]);
    };
    const regionChange = (evt) => {
        setRegions(evt.target.checked);
    };
    const setInputFile = (evt) => {
        set_input_file(evt.target.files[0]);
    };
    const setLayoutFile = (evt) => {
        set_layout_file(evt.target.files[0]);
    };
    const setRegionFile = (evt) => {
        upper_level_file_ = evt.target.files[0];
    };
    // Define cleaning temporary dir function
    const CleanServer = () => {
        const path = window.location.href;
        const url_optimize_prod_clean = path + 'sankeytools/optimize_prod_clean';
        const fetchData = {
            method: 'POST',
            body: ''
        };
        fetch(url_optimize_prod_clean, fetchData)
            .then(function (response) {
            if (!response.ok) {
                setResult(result + '\n ERROR: optimize_prod_clean a retourné une erreur qui n\'est pas en format json');
                setFailure(true);
            }
            else {
                setProcessing(false);
                setFailure(failure);
                setNotStarted(false);
            }
        })
            .catch(function () {
            setResult(result + '\n ERROR: optimize_prod_clean: erreur fatale.');
            setFailure(true);
        });
        return;
    };
    const GetRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    };
    const RetrievesResults = () => {
        // Define download excel file function
        function DownloadFile(blob) {
            const root_input_file_name = input_file_name.split('.')[0];
            let suffix = '_reconciled.xlsx';
            if (action_type.current === 'check_excel') {
                suffix = '_corrected.xlsx';
            }
            else if (action_type.current === 'create_empty_ter') {
                suffix = '_ter_created.xlsx';
            }
            const output_file_name = root_input_file_name + suffix;
            const newBlob = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            file_saver_1.default.saveAs(newBlob, output_file_name);
            return;
        }
        // Define Display Sankey function
        function DisplaySankey() {
            // Get Layout from file if asked
            if (layout_file !== undefined) {
                const reader = new FileReader();
                // Reader behavior on layout reading
                reader.onload = (() => {
                    return ((e) => {
                        let result = e.target.result;
                        if (result) {
                            result = String(result);
                            const layout = JSON.parse(result);
                            sankey_data.layout = layout;
                        }
                    });
                });
                // Read layout
                reader.readAsText(layout_file);
            }
            // Update displayed Sankey
            const root = window.location.href;
            const url_optimize_display_results = root + 'sankeytools/optimize_display_results';
            const form_data = new FormData();
            const fetchData = {
                method: 'POST',
                body: form_data
            };
            fetch(url_optimize_display_results, fetchData)
                .then(response => {
                response
                    .text()
                    .then(GetAndApplySankeyJson);
            });
        }
        // Define get results function
        function GetAndApplySankeyJson(new_sankey_json) {
            var _a;
            try {
                // Extract data as JSON
                const new_sankey_data = JSON.parse(new_sankey_json);
                // Check if we got any error
                const error = new_sankey_data['error'];
                if (error && error.length != 0) {
                    alert(error);
                    return;
                }
                // Reconcilliation from current Sankey -> Apply current layout
                if (action_type.current === 'optim_sankey') {
                    const layout = JSON.parse(JSON.stringify(sankey_data));
                    new_sankey_data.layout = layout;
                }
                const new_data = Object.assign(DefaultSankeyData(), new_sankey_data);
                (0, OpenSankey_1.ProcessExample)(new_data, OpenSankey_1.updateLayout, OpenSankey_1.convert_data, callback, DefaultSankeyData);
                const default_nstyle = DefaultSankeyData().style_node['default'];
                const default_lstyle = DefaultSankeyData().style_link['default'];
                new_data.style_node['default'] = default_nstyle;
                new_data.style_link['default'] = default_lstyle;
                delete new_data.layout;
                if (Object.values(new_data.nodeTags).filter(tagg => tagg.show_legend).length > 0) {
                    new_data.colorMap = Object.entries(new_data.nodeTags).filter(tagg => tagg[1].show_legend)[0][0];
                    Object.values(new_data.nodes).forEach(el => {
                        el.colorParameter = 'groupTag';
                        el.colorTag = new_data.colorMap;
                    });
                }
                if (Object.keys(new_data.nodeTags).filter(t => new_data.nodeTags[t].show_legend).length == 0 &&
                    Object.keys(new_data.fluxTags).filter(tag => tag === 'flux_type').length == 0 &&
                    Object.values(new_data.nodes).filter(n => n.local && n.local.color).length == 0 &&
                    Object.values(new_data.links).filter(l => l.local && l.local.color).length == 0) {
                    const color_selected = SankeyUtils_1.list_palette_color[GetRandomInt(SankeyUtils_1.list_palette_color.length)];
                    const n_keys = Object.keys(new_data.nodes);
                    const size_color = n_keys.length;
                    for (const i in d3.range(size_color)) {
                        (0, SankeyUtils_1.AssignNodeLocalAttribute)(new_data.nodes[n_keys[i]], 'color', (_a = d3.color(color_selected(+i / size_color))) === null || _a === void 0 ? void 0 : _a.formatHex());
                    }
                }
                set_sankey_data(Object.assign({}, new_data));
            }
            catch (err) {
                alert('Could not display optimized Sankey : ' + err);
            }
            return;
        }
        // Fetching results
        const path = window.location.href;
        const url_optimize_retrieves_results = path + 'sankeytools/optimize_retrieves_results';
        const form_data = new FormData();
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        fetch(url_optimize_retrieves_results, fetchData).then(function (response) {
            if (response.ok) {
                if (action_type.current === 'check_excel') {
                    CleanServer();
                }
                else {
                    response
                        .blob()
                        .then(DownloadFile)
                        .then(DisplaySankey)
                        .then(CleanServer);
                }
            }
            else {
                response
                    .json()
                    .then(data => {
                    setResult(data.output);
                    setFailure(true);
                })
                    .then(CleanServer)
                    .catch(() => {
                    setResult(result + '\n ERROR: optimize_retrieves_result a retourné une erreur qui n\'est pas en format json');
                    setFailure(true);
                });
                action_type.current = '';
                setNotStarted(true);
            }
        });
        return;
    };
    const reset = () => {
        setProcessing(false);
        setFailure(false);
        setNotStarted(true);
        if (_load_excel.current) {
            _load_excel.current.name = '';
        }
    };
    const launchReconciliation = () => {
        if (!input_file) {
            return;
        }
        // Optimisation params
        const data = new FormData();
        data.append('input_file', input_file);
        data.append('optim_sankey', String(action_type.current === 'optim_sankey'));
        data.append('create_empty_ter', String(action_type.current === 'create_empty_ter'));
        data.append('check_excel', String(action_type.current === 'check_excel'));
        data.append('uncertainty_analysis', String(uncertainty));
        data.append('nb_realizations', String(nb_realizations));
        data.append('upper_level_file', upper_level_file_.name);
        if (action_type.current === 'optim_sankey') {
            const new_sankey_data = JSON.parse(JSON.stringify(sankey_data));
            new_sankey_data.icon_catalog = {};
            data.append('sankey_data', JSON.stringify(new_sankey_data));
        }
        // POST request for optimisation
        const path = window.location.href;
        const url = path + 'sankeytools/optimize_prod_launch';
        const fetchData = {
            method: 'POST',
            body: data
        };
        fetch(url, fetchData);
        // Set processing indicators
        setProcessing(true);
        setFailure(true);
        setNotStarted(false);
        setResult('');
        if (input_file) {
            setInputFileName(input_file.name);
        }
    };
    const FinishReconciliation = () => {
        // Retrieve results
        if (!failure) {
            RetrievesResults();
        }
        else {
            CleanServer();
        }
    };
    const infos = (result !== undefined) ? result.split('\n') : [];
    let title = 'Réconciliation des données';
    if (action_type.current === 'check_excel') {
        title = 'Vérification du fichier d\'entrée';
    }
    else if (action_type.current === 'create_empty_ter') {
        title = 'Création de la table Ressources Emplois';
    }
    let success_status = 'Succés de la réconciliation';
    if (action_type.current === 'check_excel') {
        success_status = 'Vérification terminée';
    }
    else if (action_type.current === 'create_empty_ter') {
        success_status = 'Création Terminée';
    }
    let failure_status = 'Echec de la réconciliation';
    if (action_type.current === 'check_excel') {
        failure_status = 'Echec de la vérification';
    }
    else if (action_type.current === 'create_empty_ter') {
        failure_status = 'Echec de la création';
    }
    (0, react_1.useEffect)(() => {
        if (not_started && action_type.current === 'optim_sankey') {
            launchReconciliation();
        }
    });
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_reconciliation, onHide: () => set_show_reconciliation(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "R\u00E9conciliation")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                    action_type.current !== 'optim_sankey' ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                                react_1.default.createElement("h3", { style: { textAlign: 'center' } }, "Param\u00E8tres et donn\u00E9es d'entr\u00E9e"))),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Fichier d'entr\u00E9e excel")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel", ref: _load_excel, name: "", onChange: setInputFile }))),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Diagramme de mise en page")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", 
                                    //ref={layout_file_}
                                    name: "", onChange: setLayoutFile }))))) : (react_1.default.createElement(react_1.default.Fragment, null)),
                    action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', name: "regions", value: '0', id: "regions", label: "Descente d'\u00E9chelle", onChange: regionChange })))) : (react_1.default.createElement("div", null)),
                    regions && action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Fichier MFA du niveau g\u00E9ographique sup\u00E9rieur")),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { type: "file", name: "", onChange: setRegionFile })))) : (react_1.default.createElement("div", null)),
                    action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', name: "uncertainty", checked: uncertainty, id: "uncertainty", label: 'Analyse d\'incertitude', onChange: uncertaintyChange })))) : (react_1.default.createElement("div", null)),
                    uncertainty && action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Nombre de r\u00E9alisations")),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: !uncertainty, value: nb_realizations, type: "text", name: "", onChange: setNbRealisations })))) : (react_1.default.createElement("div", null)),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement("h3", { style: { textAlign: 'center' } }, title))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, input_file ?
                            (not_started ? (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: launchReconciliation }, "Lancer")) :
                                processing ? (react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning" },
                                    react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                                    "En traitement...")) : (failure ?
                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: reset }, failure_status) :
                                    react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true },
                                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: FinishReconciliation }, success_status),
                                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: reset }, "Reset")))) : (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", disabled: true, onClick: launchReconciliation }, "Lancer")))),
                    !not_started && !processing && !failure ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement(react_bootstrap_1.Alert, null, "Cliquer pour t\u00E9l\u00E9charger les r\u00E9sultats.")))) : (react_1.default.createElement("div", null)),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement("h3", { style: { textAlign: 'center' } }, "Terminal"))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 1, variant: value.includes(1) ? 'info' : 'light' }, "Infos"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 2, variant: value.includes(2) ? 'danger' : 'light' }, "Erreurs"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 3, variant: value.includes(3) ? 'warning' : 'light' }, "Debug")))),
                    processing ? (react_1.default.createElement(Counter, { value: value, result: result, setResult: setResult, setProcessing: setProcessing, setFailure: setFailure })) : (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map((info) => (value.includes(2) && info.includes('ERROR') ?
                            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
                            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                                : value.includes(3) && (info.includes('DEBUG')) ?
                                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null)))))))))));
};
exports.SupplyUseModelisationProd = SupplyUseModelisationProd;
// ---------------------------------------------------------
const Counter = ({ value, result, setResult, setProcessing, setFailure }) => {
    (0, react_1.useEffect)(() => {
        // Get process status every 5ms ?
        const interval = setInterval(() => {
            const path = window.location.href;
            const url_optimize_prod_process = path + 'sankeytools/optimize_prod_process';
            const fetchData = {
                method: 'POST',
                body: ''
            };
            fetch(url_optimize_prod_process, fetchData).then(function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        setResult(data.output);
                    });
                }
            });
        }, 5000);
        return () => clearInterval(interval);
    });
    // Detect for log message the current status of reconciliation
    const infos = (result !== undefined) ? result.split('\n') : [];
    if (infos.length > 2) {
        const info = infos[infos.length - 2];
        if (info.includes('[COMPLETED]')) {
            setProcessing(false);
            setFailure(false);
        }
        else if (info.includes('[FAILED]')) {
            setProcessing(false);
            setFailure(true);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map(info => (value.includes(2) && info.includes('ERROR') ?
            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                : value.includes(3) && (info.includes('DEBUG')) ?
                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null))))));
};
